import React from "react";
import PropTypes from "prop-types";

/**
 * Componente TabPane
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro da aba.
 * @param {string} props.id - O identificador exclusivo da aba.
 * @param {boolean} [props.ativo=false] - Um sinalizador indicando se a aba está ativa ou não.
 * @returns {ReactElement} O elemento React renderizado que representa o conteúdo da aba.
 */
function TabPane({ children, id, ativo = false }) {
  return (
    <div className={`tab-pane ${ativo && "active"}`} id={id} role="tabpanel">
      {children}
    </div>
  );
}

TabPane.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  ativo: PropTypes.bool,
};

export default TabPane;
